import script from "./SignFormSummary.vue?vue&type=script&lang=ts&setup=true"
export * from "./SignFormSummary.vue?vue&type=script&lang=ts&setup=true"

import "./SignFormSummary.vue?vue&type=style&index=0&id=a7f83e16&lang=scss&scoped=true"

import exportComponent from "E:\\svn\\xmTask(国振资产管理)1\\views\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a7f83e16"]])

export default __exports__